import { render, staticRenderFns } from "./userDetailsGrid.vue?vue&type=template&id=d966066a&scoped=true"
import script from "./userDetailsGrid.vue?vue&type=script&lang=js"
export * from "./userDetailsGrid.vue?vue&type=script&lang=js"
import style0 from "./userDetailsGrid.vue?vue&type=style&index=0&id=d966066a&lang=scss&scoped=true"
import style1 from "./userDetailsGrid.vue?vue&type=style&index=1&id=d966066a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d966066a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/3e17078e833b83b1/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d966066a')) {
      api.createRecord('d966066a', component.options)
    } else {
      api.reload('d966066a', component.options)
    }
    module.hot.accept("./userDetailsGrid.vue?vue&type=template&id=d966066a&scoped=true", function () {
      api.rerender('d966066a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/historical/user-details-view/userDetailsGrid.vue"
export default component.exports